export default __webpack_public_path__ + "static/media/video.a3b7ef39.svg";